import { observer } from 'mobx-react';
import LockIcon from '../../../../../../../Cutesies/LockIcon';
import { Experience } from '../../Types';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  payload: Experience;
}

function UnLicensedIcon({ payload }: Props) {
  switch (payload.status) {
    case 'Unlicensed':
      return (
        <span className="absolute right-0 translate-y-1/2 bottom-0 transform bg-white rounded-full w-5 h-5 mr-1 mb-1 flex items-center justify-center">
          <LockIcon />
        </span>
      );
    case 'Licensed':
      return emptyFragment();
  }
}

export default observer(UnLicensedIcon);
